import { Locale } from '@ps-smart-cp/ppfw-client';

const paymentMethodConfig = {
  advancePayment: new Map([[Locale.ja, '先払い']]),
  laterPayment: new Map([[Locale.ja, '後払い']]),
};

export { paymentMethodConfig };
